// src/components/VideoStep.js

import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';

const VideoStep = ({ videoUrl, audioUrl, onNext = () => {}, onError = () => {} }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasVideoError, setHasVideoError] = useState(false);
  const [hasAudioError, setHasAudioError] = useState(false);
  const videoRef = useRef(null);
  const audioRef = useRef(null);

  const handleNext = () => {
    onNext({ interested: true });
  };

  const handleVideoError = (e) => {
    console.error('Error loading video:', videoUrl);
    setHasVideoError(true);
    onError('Erro ao carregar o vídeo');
  };

  const handleAudioError = (e) => {
    console.error('Error loading audio:', audioUrl);
    setHasAudioError(true);
    onError('Erro ao carregar o áudio');
  };

  if (!videoUrl || hasVideoError) {
    return (
      <div className="text-center p-8">
        <p className="text-gray-600 text-lg">Vídeo não disponível</p>
        <button
          onClick={handleNext}
          className="mt-6 px-12 py-4 rounded-lg text-lg font-medium bg-[#e91e63] text-white hover:bg-[#d81557] transition-colors"
        >
          Continuar
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-8 max-w-4xl mx-auto p-6">
      <div className="text-center">
        <h3 className="text-2xl font-semibold text-gray-900 mb-4">
          Vídeo de Verificação
        </h3>
      </div>

      <div className="space-y-8">
        <div className="aspect-video bg-black rounded-xl overflow-hidden shadow-lg">
          <video
            ref={videoRef}
            src={videoUrl}
            className="w-full h-full object-contain"
            onError={handleVideoError}
            controls
            playsInline
          />
        </div>

        <div className="space-y-6">
          <div className="flex items-center justify-center gap-4 text-lg">
            <p className="text-gray-600">
              Escute minha voz
            </p>
            <span className="text-[#e91e63] font-medium">
              Quer encontrar comigo?
            </span>
          </div>

          {audioUrl && !hasAudioError && (
            <div className="bg-gray-100 rounded-xl p-6 max-w-2xl mx-auto shadow-sm">
              <audio
                ref={audioRef}
                src={audioUrl}
                className="w-full"
                onError={handleAudioError}
                controls
              />
            </div>
          )}
        </div>

        <div className="flex justify-center pt-4">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.98 }}
            animate={{
              scale: [1, 1.05, 1],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              repeatType: "reverse"
            }}
            onClick={handleNext}
            className="px-16 py-5 rounded-xl text-xl font-semibold bg-[#e91e63] text-white hover:bg-[#d81557] transition-colors shadow-lg"
          >
            Quero muito
          </motion.button>
        </div>
      </div>
    </div>
  );
};

export default VideoStep;
